import { combineReducers } from 'redux';
import flatten from 'lodash/flatten'; // eslint-disable-line
import byParent, * as fromByParent from './byParent';
import byId, * as fromById from './byId';//eslint-disable-line

/* Reducers: */
const related = combineReducers({
  byParent,
  byId,
});

export default related;

/* Selectors: */
export const getTypes = (state, contentId) => {
  const types = fromByParent.getTypes(state.byParent, contentId);
  return types ? types.map(item => item.type) : [];
};

export const getRelated = (state, contentId, type) => {
  const ids = fromByParent.getTypes(state.byParent, contentId)
    .filter(item => item.type === type).map(item => item.ids);
  const flattened = flatten(ids);

  return flattened.map(item => fromById.getRelated(state.byId, item));
};

export const getIsFetching = state =>
  fromByParent.getIsFetching(state.byParent);



// WEBPACK FOOTER //
// ./js/reducers/related/index.js